export enum PaymentMethod{
    wechat = 'WechatPay',
    paypal = 'PayPal',
    creditcard = 'CreditCard'
}